import type { FaireProductEntity } from "../../entity_types/product";

export const p_4zx3x5qhmt: FaireProductEntity = {
  token: "p_4zx3x5qhmt",
  type: "product",
  name: "Serena Halter Neck Corset Maxi Dress – Brown Satin Evening Gown",
  brandToken: "b_mdfcwdnw57",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b5b42488033375f7cee9757497bf1d05648f7b38197ab9183a2314439f73d3d1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1006e791cf002439e0d3c5a64fb80a8ebf219b39ab24d502e9ad70592ed92f30.png",
    "https://cdn.faire.com/fastly/38a59277ddba1ff14d502cc94483c84c712608b418c1dcfcc04352e84bc8562a.png",
    "https://cdn.faire.com/fastly/97f2f467a999fafecab85727e3bfedbe14df70250d44c8bd7d74f4fe406eada4.png",
    "https://cdn.faire.com/fastly/f161eb7faf161944049adfa69a3b898cf47ce543d32dbaeeeddf30dc104d4bee.png",
    "https://cdn.faire.com/fastly/ae074dedb2657fb39da8825d92a889a0e963f01387341134cdabbd86be775891.jpeg",
  ],
  priceDollars: 51.96,
  description:
    "Serena Halter Neck Corset Maxi Dress is a refined evening silhouette designed to highlight the waist and elongate the figure. The structured corset-style bodice offers a supportive fit, while the halter neckline creates an open, elegant shoulder line. The satin-finish skirt drapes smoothly over the hips, adding movement and a subtle sheen that works beautifully for formal events, evening dinners, and special occasions.\n\nThe adjustable side ties allow for a customized fit through the waist and hips, balancing structure with comfort. This maxi-length dress pairs effortlessly with heels and minimal jewelry for a polished, confident look.\n\nFabric composition: Polyester blend with a smooth satin finish\n\nFit: Fitted bodice with flowing skirt\n\nNeckline: Halter neck\n\nLength: Maxi\n\nStretch: Low to moderate\n\nOccasion: Evening wear, formal events, cocktail parties\n\nSize Guide (cm / inches)\n\nS — Bust 75–89 cm (29.5–35.0 in), Waist 63–75 cm (24.8–29.5 in), Hips 75 cm (29.5 in), Length 122 cm (48.0 in)\n\nM — Bust 79–93 cm (31.1–36.6 in), Waist 67–79 cm (26.4–31.1 in), Hips 79 cm (31.1 in), Length 124 cm (48.8 in)\n\nL — Bust 85–99 cm (33.5–39.0 in), Waist 73–85 cm (28.7–33.5 in), Hips 83 cm (32.7 in), Length 126 cm (49.6 in)\n\nMeasurements are taken manually. Please allow a 1–3 cm (0.4–1.2 in) difference.\n",
  tags: [],
  msrpDollars: 103.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:32.785Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
